import { useQuery } from '@ts-core/lib/apollo';

import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';
import { ProfessorActivityAnswer } from '../types';

import { getActivityAnswerQuery, GetActivityAnswerQueryResult, GetActivityAnswerQueryVariables } from '../graphql/queries/getActivityAnswerQuery';

interface ActivityAnswerHookInput {
  courseId: string;
  activityId: string;
  answerId: string;
}

interface ActivityAnswerHookOutput {
  answer?: ProfessorActivityAnswer;
  loading: boolean;
}

export default function useActivityAnswers(input: ActivityAnswerHookInput): ActivityAnswerHookOutput {
  const { courseId, activityId, answerId } = input;
  const { showErrorNotification } = useSnackbarNotifications();

  const { data, loading } = useQuery<GetActivityAnswerQueryResult, GetActivityAnswerQueryVariables>(getActivityAnswerQuery, {
    variables: { courseId, activityId, answerId },
    onError: showErrorNotification,
  });

  return {
    answer: data?.answer,
    loading,
  };
}
